import { useState } from "react";
import SummaryApi from "../common";
import fetchWithAuth from "../common/fetchWithAuth";


const useBank = () => {
    const [loading, setLoading] = useState(false);


    const addBank = async (bankData) => {
        setLoading(true);
        try {
            const res = await fetchWithAuth(SummaryApi.addBank.url, {
                method: SummaryApi.addBank.method,
                body: JSON.stringify(bankData)
            });
            const data = await res.json();
            if (!res.ok) {
                throw new Error(data.message || 'failed to Add Bank Details');
            }
            return data;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const getBankDetails = async () => {
        setLoading(true);
        try {
            const res = await fetchWithAuth(SummaryApi.getBankDetails.url, {
                method: SummaryApi.getBankDetails.method,
            });
            const bankData = await res.json();
            if (!res.ok) {
                throw new Error(bankData.message || 'failed to fetch Bank Details');
            }
            return bankData;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const getBankDetailsById = async (id) => {
        setLoading(true);
        try {
            const res = await fetchWithAuth(SummaryApi.getBankDetailsById.url(id), {
                method: SummaryApi.getBankDetailsById.method,
            });
            const bankData = await res.json();
            if (!res.ok) {
                throw new Error(bankData.message || 'failed to fetch Bank Details');
            }
            return bankData;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const updateBank = async (id, bankData) => {
        setLoading(true);
        try {
            const res = await fetchWithAuth(SummaryApi.updateBank.url(id), {
                method: SummaryApi.updateBank.method,
                body: JSON.stringify(bankData)
            });
            const data = await res.json();
            if (!res.ok) {
                throw new Error(data.message || 'failed to Update Bank Details');
            }
            return data;
        } catch (err) {
            throw err;
        } finally {
            setLoading(false);
        }
    }

    const getBankTransaction = async (bankId) => {
        try {
            let url = SummaryApi.getBankTransaction.url;
            if (bankId) {
                url += `?bankId=${bankId}`;
            }

            const res = await fetchWithAuth(url, {
                method: SummaryApi.getBankTransaction.method,
            });
            const bankTransaction = await res.json();
            if (!res.ok) {
                throw new Error(bankTransaction.message || 'failed to fetch Bank Details');
            }
            return bankTransaction;
        } catch (err) {
            throw err;
        }
    }

    return {
        loading,
        addBank,
        getBankDetails,
        getBankDetailsById,
        getBankDetailsById,
        getBankTransaction,
        updateBank
    }
}

export default useBank;
